"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _base = require("@atlaskit/icon/base");

var warnOnce = require("@atlaskit/ds-lib/warn-once").default;

warnOnce("The '@atlaskit/icon-priority' package has been deprecated due to its limited usage in Cloud Products. If you depend on '@atlaskit/icon-priority' we recommend self-managing the assets.")

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PriorityTrivialIcon = props => /*#__PURE__*/_react.default.createElement(_base.Icon, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M12 20a8 8 0 100-16 8 8 0 000 16zm0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" fill="#7A8699"/></svg>`
}, props));

PriorityTrivialIcon.displayName = 'PriorityTrivialIcon';
var _default = PriorityTrivialIcon;
exports.default = _default;
